// tslint:disable: variable-name
import { IsDeleted } from '../../../kernel/base/value';
import { Column, getColumns } from '../../../../utility/decorator/entity/column.decorator';
import { Entity } from '../../../../utility/model/entity.model';
import { Timestamp } from '../../../../utility/model/timestamp.value';
import { AccountOrganizationId } from '../../account/value';
import { ReactionId, ReactionType, ReactionTargetType, ReactionChosen } from '../value';
import { PostId } from '../../../kernel/post';

export class Reaction implements Entity {
  @Column()
  readonly id: ReactionId;
  @Column()
  postId: PostId;
  @Column()
  target: ReactionTargetType;
  @Column()
  type: ReactionType;
  @Column()
  chosen: ReactionChosen;
  @Column()
  reactedBy: AccountOrganizationId;
  @Column()
  createdAt: Timestamp;
  @Column()
  updatedAt: Timestamp;
  @Column()
  isDeleted: IsDeleted;

  constructor(id: ReactionId) {
    this.id = id;
  }

  static get allFields(): (keyof Reaction)[] {
    return getColumns(new Reaction(ReactionId.create('')));
  }

  equals(value: Reaction): boolean {
    return this.id.equals(value.id);
  }
}
